import { SelfPosition } from "@pageBuilder/typings";

export class AlignmentUtil {

    // Safari 13 does not support "start" and "end" values
    public static correctAlignmentStyle(alignment?: SelfPosition | null): SelfPosition | null | undefined {
        if (alignment === "start") {
            return "flex-start";
        } else if (alignment === "end") {
            return "flex-end";
        }

        return alignment;
    }

    public static getFromAlignableItem(element: HTMLElement): SelfPosition {
        return element.classList.contains("start") || element.classList.contains("justify-start")
            ? "start"
            : element.classList.contains("end") || element.classList.contains("justify-end")
                ? "end"
                : "center";
    }

}
